<template>
  <div
    class="fixed w-52 right-0 bg-background-normal rounded-xl hover-container transition-all duration-300 ease-in-out"
    style="z-index: 1000; background: rgba(6, 7, 16, 0.92); left: 292px; bottom: 20px;"
  >
    <!-- Top Text -->
    <div class="flex justify-between items-center px-3 pt-3">
      <!-- Top Text -->
      <BaseText
        type="label"
        size="sm"
        class="text-white font-medium"
      >
        Data Sync
      </BaseText>
      <BaseText
        type="body"
        size="sm"
        class="text-white opacity-70"
      >
        Importing...
      </BaseText>
    </div>

    <!-- Progress Bar -->
    <div class="w-full py-1.5 mt-1 mb-1 flex items-center justify-between">
      <div
        class="w-full h-2 ml-3 mr-2 flex-grow rounded-full"
        style="background: rgba(255, 255, 255, 0.12);"
      >
        <div
          class="h-full bg-secondary-green-100 rounded-full transition-all duration-300 ease-in-out"
          :style="{ width: importProgress + '%' }"
        />
      </div>

      <BaseText
        type="body"
        size="xs"
        class="text-white opacity-70 mr-3 whitespace-nowrap"
      >
        {{ progressText.header }}
      </BaseText>
    </div>
    <!-- Bottom Text -->
    <div
      class="m-1 rounded-lg hidden-content transition-all duration-300 ease-in-out"
      style="background: rgba(255, 255, 255, 0.06);"
    >
      <!-- Bottom Text -->
      <BaseText
        type="body"
        size="xs"
        class="text-white opacity-70"
      >
        {{ progressText.detail }}
      </BaseText>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LensDataImportingFloater',
  props: {
    importProgress: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      progress: 0
    }
  },
  computed: {
    progressText () {
      return {
        header: `${Math.floor(this.importProgress)}%`,
        detail: `You can now access ${this.importProgress?.toFixed(1)}% of your data.`
      }
    }
  }
}
</script>

<style scoped>
.hidden-content {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  margin: 0;
  padding: 0 8px 0 8px;
}

.hover-container {
  transform: translateY(0);
}

.hover-container:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.hover-container:hover .hidden-content {
  max-height: 50px;
  opacity: 1;
  margin: 4px;
  padding: 8px;
}
</style>
